import {
  ContractPharmacyLinkParams,
  ContractPharmacyMappingDetails,
  InhousePharmacyLinkParams,
  InhousePharmacyMappingDetails
} from '@module-claims/models/pharmacy.interface';

export class ClearPharmacyDetails {
  static readonly type = '[ Pharmacy ] Clear Pharmacy Details';
}

export class GetPharmacyDetails {
  static readonly type = '[ Pharmacy ] Get Pharmacy Details';

  constructor(public npi: string) {}
}

export class ClearContractPharmacyDetails {
  static readonly type = '[ Pharmacy ] Clear Contract Pharmacy Details';
}

export class GetContractPharmacyDetails {
  static readonly type = '[ Pharmacy ] Get Contract Pharmacy Details';

  constructor(public hrsaPharmacyId: string) {}
}

export class LinkContractPharmacy {
  static readonly type = '[ Pharmacy ] Link Contract Pharmacy';

  constructor(public params: ContractPharmacyLinkParams) {}
}

export class UnlinkContractPharmacy {
  static readonly type = '[ Pharmacy ] Unlink Contract Pharmacy';

  constructor(
    public npi: string,
    public contractPharmacy: ContractPharmacyMappingDetails
  ) {}
}

export class ClearInhousePharmacyDetails {
  static readonly type = '[ Pharmacy ] Clear Inhouse Pharmacy Details';
}

export class GetInhousePharmacyDetails {
  static readonly type = '[ Pharmacy ] Get Inhouse Pharmacy Details';

  constructor(public id340b: string) {}
}

export class LinkInhousePharmacy {
  static readonly type = '[ Pharmacy ] Link Inhouse Pharmacy';

  constructor(public params: InhousePharmacyLinkParams) {}
}

export class UnlinkInhousePharmacy {
  static readonly type = '[ Pharmacy ] Unlink Inhouse Pharmacy';

  constructor(
    public npi: string,
    public inhousePharmacy: InhousePharmacyMappingDetails
  ) {}
}

export class ContractPharmacyModalSave {
  static readonly type = '[ Contract Pharmacy ] Modal save event';

  constructor(public params: ContractPharmacyLinkParams) {}
}

export class ContractPharmacyModalClose {
  static readonly type = '[ Contract Pharmacy ] Modal close event';
}

export class InhousePharmacyModalSave {
  static readonly type = '[ Inhouse Pharmacy ] Modal save event';

  constructor(public params: InhousePharmacyLinkParams) {}
}

export class InhousePharmacyModalClose {
  static readonly type = '[ Inhouse Pharmacy ] Modal close event';
}
